"use client";

import React, { useEffect, useState } from "react";
import QRCodeLib from "qrcode";

// styles
import * as S from "./styles";
import { QrCode, ShieldCheck, ShieldX } from "lucide-react";
import Spinner from "../spinner/loading";
import Image from "../image";

import qrCode from "@/assets/images/qrCode.png";

type StatusType =
  | "connected"
  | "checking"
  | "disconnected"
  | "generateQR"
  | "qrCode";

type Props = {
  status: StatusType;
  qrImage?: string | null; // base64 image from backend (optional)
  qrCodeString?: string | null; // raw code payload to render as QR if image missing
};

const BoxAlertMessage: React.FC<Props> = ({
  status,
  qrImage = null,
  qrCodeString = null,
}) => {
  const [generatedQr, setGeneratedQr] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const gen = async () => {
      if (!qrCodeString) {
        setGeneratedQr(null);
        return;
      }
      try {
        const dataUrl = await QRCodeLib.toDataURL(qrCodeString, {
          margin: 1,
          width: 300,
        });
        if (mounted) setGeneratedQr(dataUrl);
      } catch (err) {
        console.error("QR generation error:", err);
        if (mounted) setGeneratedQr(null);
      }
    };

    gen();
    return () => {
      mounted = false;
    };
  }, [qrCodeString]);

  const renderContent = () => {
    switch (status) {
      case "connected":
        return (
          <>
            <ShieldCheck />
            <S.Description>Whatsapp conectado</S.Description>
          </>
        );
      case "checking":
        return (
          <>
            <Spinner />
            <S.Description>
              Verificando conexão com whatsapp, por favor aguarde...
            </S.Description>
          </>
        );
      case "generateQR":
        return (
          <>
            <Spinner />
            <S.Description>
              Gerando QR Code para conexão com o WhatsApp...
            </S.Description>
          </>
        );
      case "qrCode":
        return (
          <>
            <QrCode />
            <S.Description>
              Após Conectar o WhatsApp Clique no Botão Verificar
            </S.Description>
            <S.BoxQRCode>
              {/* prefer backend image, else generated from `code`, else fallback */}
              {qrImage ? (
                <Image src={qrImage} />
              ) : generatedQr ? (
                <Image src={generatedQr} />
              ) : (
                <Image src={qrCode} />
              )}
            </S.BoxQRCode>
          </>
        );
      case "disconnected":
      default:
        return (
          <>
            <ShieldX />
            <S.Description>Whatsapp desconectado</S.Description>
          </>
        );
    }
  };

  return <S.Box $status={status}>{renderContent()}</S.Box>;
};

export default BoxAlertMessage;
